import React from 'react';
import { STATUS_BADGE_MAP, STATUS_LABEL_ID } from '../lib/constants';

export const StatusBadge = ({ status, className = '', testid }) => {
  if (!status) return null;
  const cls = STATUS_BADGE_MAP[status] || 'bg-slate-400/10 text-slate-200 border-slate-400/25';
  const label = STATUS_LABEL_ID[status] || status;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls} ${className}`}
    >
      {label}
    </span>
  );
};
